import { render, staticRenderFns } from "./transactionsList.vue?vue&type=template&id=f3fb8346&"
import script from "./transactionsList.vue?vue&type=script&lang=js&"
export * from "./transactionsList.vue?vue&type=script&lang=js&"
import style0 from "./transactionsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports